import { ProductSetViewModel } from '~/lib/data-contract/auto-generated/product-model';
import { runtimeConfig } from '~/shared/utils/public-variables';
import { fetcher } from './fetcher';

export type ProductRequestPath = {
    franchiseAPIPath: string;
    productIds: string;
    headers?: HeadersInit;
    opts?: RequestInit;
};

export type ProductResponseType = ProductSetViewModel & { statusCode: number };

const { COMMERCE_URL } = runtimeConfig();
/**
 * Fetch product
 */
export async function fetchProductSet({
    franchiseAPIPath,
    productIds,
    headers,
    opts,
}: ProductRequestPath): Promise<ProductResponseType> {
    const request = await fetcher<ProductSetViewModel>(
        `${COMMERCE_URL}/${franchiseAPIPath}/Product/set/${productIds}`,
        {},
        headers,
        opts
    );

    const response = await request.json();

    return { ...response, statusCode: request.status };
}
